import React, { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import { xlsxCustomExport } from '../utils/chartConfig';

const IMG_URL = process.env.IMG_FULL_URL;

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

class WorkRelatedDiseasesLineChart extends Component {
    constructor(props){
        super(props);

		let currentChart = props.chartType[0];
		let selectedTypeChart = props.chartType[0].type;
		if (props.selectedIndicator != undefined)
		{
			selectedTypeChart = props.selectedIndicator;
			currentChart = props.chartType.find((chart) => chart.type == selectedTypeChart);
		}

        this.state = {
			selectedTypeChart,
			currentChart,
            chartConfig: {
				title: {
					text: props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.title+"</h2>",
					align: 'left',
					widthAdjust: -50,
					y:20,
					style: {
						zIndex: 1,
						lineHeight:36
					}	
				},
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
				},
				colors: this.props.colors,
				chart: {
					//height must be configured in scss because in the full screen view isn´t shown properly otherwise. 
					//height: this.props.fullCountryReport ? 500 : 250,
					type: "line",
					backgroundColor: '#F0F0F0',
					events: {
						render: function() {
                            let chart = this;
						    if (!chart.customImage)
						    {
							    chart.customImage = chart.renderer.image(
								    `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
								    chart.chartWidth - 130,
								    chart.chartHeight - 37,
								    130,
								    37
							    ).add();
                                chart.customImage.attr({
									class:'osha-logo'
								});
						    }
						    else
						    {
							    chart.customImage.attr({
                                    x: chart.chartWidth - 130,
                                    y: chart.chartHeight - 37
							    });
						    }
					
						    if (chart.fullscreen.isOpen) {
							    chart.customImage.css({
								   display: 'block'
							    });
                                chart.container.className = 'highcharts-container full-screen';
                            }
						    else
						    {
							    chart.customImage.css({
								    display: ''
							    });	
							    chart.container.className = 'highcharts-container';
						    }
						}					
					},
				},
				exporting: {
					enabled: this.props.fullCountryReport == true ? false : true,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
						}
					},
					menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Country', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 0
					}
				},
				legend:{
					itemMarginTop:4,
					itemMarginBottom:4,
					itemDistance: 5,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:'11px',
						textOverflow: "ellipsis",
						//width: 250
					}
				},
				tooltip: {
					useHTML: true,
					opacity: 1,
					borderColor:"#529FA2",
					backgroundColor: "rgba(255, 255, 255, 1)",
					style: {
						zIndex: 100
					},
					formatter: function () {
						let chartTitle = this.series.chart.title.textStr;
						let numberOfDecimals = 1;
						if (chartTitle.indexOf("DALY") > -1)
						{
							numberOfDecimals = 0;
						}
						return '<ul class="tooltip-item">'+
						'<li><strong>Country: </strong>'+ this.series.name +' </li>' +
						'<li><strong>Year: </strong>'+ this.x  +' </li>' +
						'<li><strong class="tooltip-value up">Value: </strong> '+ Highcharts.numberFormat(this.y,numberOfDecimals,',','.') + '</li>' +
						'</ul>';
					}
				},

				plotOptions: {
					series: {
						stacking: this.props.stacking
					},
					line: {
						borderWidth: 0,
						dataLabels: {							
							enabled: this.props.showDataLabel === true ? true : false,
							formatter: function () {
								return '<span style="color:' + this.point.color + '">' + Highcharts.numberFormat(this.y, 0, '.', ',')   + '</span>';
							},							
							style: {
								textOutline: false,
								fontFamily: 'OpenSans-bold',
								fontWeight: 'normal',
								fontSize:this.props.fullCountryReport? '16px' : '12px'
							}
						}
					}
				},
				xAxis: {
					lineWidth: 0,
					categories: [],
					labels: {
						formatter: function () {
							return "<span style='color:#808080'>" + [this.value] + "</span>"
						},
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: '12px'
						}
					}
				},
				yAxis: {
					lineWidth: 0,
					gridLineColor: '#FFF',
          			gridLineWidth: 2,
					title: {
						enabled: false
					},
					labels: {
						format: undefined,					
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: '12px'
						}
					}
				},
				series: [ ]
			},
            isLoading: false
        }
    }

    getLoadData = (chart, indicator, illness, country1, country2, country3) => {
		this.getCredits(chart);

		let requestFilter = {
			chart,
			indicator,
			country1,
			country2,
			country3,
			illness
		}
        getNewChartData(requestFilter)
        .then((response) =>
        {
			let yAxisLabel = undefined;
			if (chart=="20133" && illness=="11")
			{
				yAxisLabel = "{value:.2f}";
			}
            this.setState({ chartConfig: {...this.state.chartConfig, 
				xAxis:{...this.state.chartConfig.xAxis, categories: response.resultset.xAxisCategories}, 
				yAxis: {...this.state.chartConfig.yAxis, labels: {...this.state.chartConfig.yAxis.labels, format: yAxisLabel } },
				series: response.resultset.data }} )
        })
	}

	getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

	onChangeSelect = (e) => {
		this.props.callbackDiseasesSource(e.target.value);
        this.setState({ selectedTypeChart: e.target.value });
    }

    componentDidMount() {
        this.getLoadData(this.state.currentChart.chart, this.state.currentChart.chartIndicator, this.state.currentChart.illness, this.props.country1, this.props.country2, this.props.country3);
    }
    
    componentDidUpdate(prevProps, prevState) {
		if (prevState.selectedTypeChart != this.state.selectedTypeChart || prevProps.chartType != this.props.chartType)
		{
			let currentChart;
			if (this.props.chartType.length == 1)
			{
				currentChart = this.props.chartType[0];
			}
			else
			{
				currentChart = this.props.chartType.find((chart) => this.state.selectedTypeChart == chart.type);
			}

			this.getLoadData(currentChart.chart, currentChart.chartIndicator, currentChart.illness, this.props.country1, this.props.country2, this.props.country3);

			this.setState( { currentChart, chartConfig: {...this.state.chartConfig, title: {...this.state.chartConfig.title, text: "<h2 class='title--card'>"+this.props.literals[`L${currentChart.title}`]+"</h2>"} } } );
		}

        if (prevProps.chart != this.props.chart || prevProps.indicator != this.props.indicator || prevProps.illness != this.props.illness 
			|| prevProps.country1 != this.props.country1 || prevProps.country2 != this.props.country2 || prevProps.country3 != this.props.country3)
		{
			this.getLoadData(this.state.currentChart.chart, this.state.currentChart.chartIndicator, this.state.currentChart.illness, this.props.country1, this.props.country2, this.props.country3);
		}
    }

    render() {

		let selectOptions = this.props.chartType.map((chart) => chart.type);
		let selectDiv = (
			selectOptions.length > 1 && !this.props.fullCountryReport && (
				<div className="select-filter-chart">
					<select onChange={this.onChangeSelect} value={this.state.selectedTypeChart} >
						{selectOptions.map((type) => {
							return <option key={type} value={type} > {type.toUpperCase()} </option>
						})}
					</select>
				</div>
			)
		)

        return(
			<React.Fragment>
				{selectDiv && (
					<div className='chart--filters--block'>
                	    {selectDiv}
                	</div>
				)}
				<div className='chart-container'>
					<HighchartsReact
						highcharts={Highcharts}
						options={this.state.chartConfig}
						containerProps={{ className: 'chartContainer' }}
					/>
				</div>
			</React.Fragment>            
        )
    }
}

export default WorkRelatedDiseasesLineChart;